import { Alert, Button, Card, Col, Form, Input, message, Radio, Row, Select, Switch } from 'antd'
import apiClient from 'services/apiClient'
import React, { useEffect, useState } from 'react'

import { useMyContext } from 'Context/MyContextProvider';
import { useLocation } from 'react-router-dom';
import { motion } from "framer-motion"
import Flex from 'components/shared-components/Flex';
import "react-transliterate/dist/index.css";

import CarouselPreview from '../carouselPreview';
import SelectMediaModel from '../../Campaign/CampainComps/SelectMediaModel';
import { generatePayload, HandleCarouselTemplate, HandleDynamicValues, handleUrlButtonChange } from '../CarouselCampaignComps.js/carouselUtils';
import CardData from '../CarouselCampaignComps.js/CardData';
import { ErrorExtractor } from '../../CustomUtils.js/utils';
import { useTemplates } from 'hooks/api';

const CarouselCampaign = () => {
    const { UserData, api, authToken, Permisson, navigate, buttonStyle } = useMyContext()
    const { templates } = useTemplates()
    useEffect(() => {
        if (!Permisson?.includes('View Campaign')) {
            navigate('404')
        }
    }, [Permisson]);
    const location = useLocation();

    const [templateList, setTemplateList] = useState([]);
    const [componentSize, setComponentSize] = useState('small');
    const [number, setNumber] = useState('');
    const [numberError, setNumberError] = useState(false);
    const [dynamicValues, setDynamicValues] = useState([]);
    const [templateName, setTemplateName] = useState('');
    const [newMesaage, setNewMessage] = useState('');
    const [name, setName] = useState('');
    const [templatePreview, setTemplatePreview] = useState([])
    const [mediaLink, setMediaLink] = useState('')
    const [thumbnail, setThumbnail] = useState('')
    const [templateKey, setTemplateKey] = useState(0);
    const [urlButtons, setUrlButtons] = useState([]);

    const [error, setError] = useState('');
    const [templateCategory, setTemplateCategory] = useState();
    const [templateLanguage, setTemplateLanguage] = useState('');
    const [openMediaModel, setOpenMediaModel] = useState(false);
    const [loading, setLoading] = useState(false);

    const [initialTemplates, setInitialTemplates] = useState([]);
    const [mainBody, setMainBody] = useState(null);

    const [mainBodyInputs, setMainBodyInputs] = useState([]);

    const [cardData, setCardData] = useState([]);
    const [currentCardIndex, setCurrentCardIndex] = useState(0);
    const [cards, setCards] = useState();
    const [cardButtonValues, setCardButtonValues] = useState({});

    //edit states
    const [isEditing, setIsEditing] = useState(false);
    const [editId, setEditId] = useState(false);
    const [existingMediaIDs, setExistingMediaIDs] = useState([]);


    useEffect(() => {
        // Check if we're in edit mode
        if (location.state?.isEditing && location.state?.presetData) {
            const presetData = location.state.presetData;
            setIsEditing(location.state?.isEditing)
            setEditId(presetData?.id)
            let Object = JSON.parse(presetData?.object)

            // Find the CAROUSEL component instead of assuming it's at index 0
            const carouselComponent = Object.template.components.find(comp => comp.type === 'CAROUSEL');
            let cards = carouselComponent?.cards;

            // Extract dynamic values from cards with their card index
            const extractedDynamicValues = [];
            if (cards && cards.length > 0) {
                cards.forEach((card, cardIndex) => {
                    if (card.components) {
                        card.components.forEach(component => {
                            if (component.parameters) {
                                component.parameters.forEach(param => {
                                    if (param.type === 'TEXT' && param.text) {
                                        extractedDynamicValues.push({
                                            cardIndex: cardIndex,
                                            value: param.text
                                        });
                                    }
                                });
                            }
                        });
                    }
                });
            }

            // Extract image IDs from the cards with proper error handling
            const imageIds = cards?.map(card => {
                // Look for HEADER component with IMAGE parameter
                const headerComponent = card.components?.find(comp => comp.type === 'HEADER');
                const imageParam = headerComponent?.parameters?.find(param => param.type === 'IMAGE');
                return imageParam?.image?.id;
            }).filter(id => id !== undefined && id !== null);

            // Extract existing button values
            const existingButtonValues = {};
            cards?.forEach((card, cardIndex) => {
                card.components?.forEach((component) => {
                    if (component.type === 'BUTTON' && component.sub_type === 'URL' && component.parameters) {
                        const textParam = component.parameters.find(param => param.type === 'text');
                        if (textParam && textParam.text) {
                            // Use the same key format as used in the form
                            existingButtonValues[`${cardIndex}_${component.index || 0}`] = textParam.text;
                        }
                    }
                });
            });
            setCardButtonValues(existingButtonValues);

            let TemplateName = Object?.template?.name;
            setTemplateCategory(presetData?.category)
            setName(presetData?.name)

            // Set the existing media IDs directly to card data after template is handled
            setTimeout(() => {
                const flatDynamicValues = extractedDynamicValues.map(item => item.value);
                setDynamicValues(flatDynamicValues);
                HandleTemplate(TemplateName, flatDynamicValues);
                setExistingMediaIDs(imageIds);

                // Update cardData with media AND dynamic values
                setCardData(prevCardData =>
                    prevCardData.map((card, cardIndex) => {
                        // Filter dynamic values for this specific card
                        const cardDynamicValues = extractedDynamicValues.filter(
                            item => item.cardIndex === cardIndex
                        );

                        // Update inputs with their corresponding values
                        const updatedInputs = card.inputs?.map((input, inputIndex) => {
                            const dynamicValue = cardDynamicValues[inputIndex]?.value || '';
                            return {
                                ...input,
                                props: {
                                    ...input.props,
                                    initialValue: dynamicValue,
                                    children: {
                                        ...input.props.children,
                                        props: {
                                            ...input.props.children.props,
                                            value: dynamicValue
                                        }
                                    }
                                }
                            };
                        });

                        return {
                            ...card,
                            mediaLink: (imageIds && imageIds[cardIndex]) || card.mediaLink,
                            mediaName: `Media ${cardIndex + 1}`,
                            inputs: updatedInputs
                        };
                    })
                );
            }, 100);
        }
    }, [location.state]);

    useEffect(() => {
        if (templates.length > 0) {
            const carouselTemplates = templates?.filter(template =>
                template.components?.some(comp => comp.type === 'CAROUSEL')
            );
            setInitialTemplates(carouselTemplates)
            setTemplateList(carouselTemplates)
        }
    }, [templates])

    useEffect(() => {
        if (templateCategory) {
            const filteredList = initialTemplates.filter(item => item.category === templateCategory);
            setTemplateList(filteredList);
        } else {
            setTemplateList(initialTemplates);
        }
    }, [templateCategory, initialTemplates]);

    const onFormLayoutChange = ({ size }) => {
        setComponentSize(size);
    };

    useEffect(() => {
        if (number) {
            setNumberError(false)
        }
    }, [number])

    const HandleTemplate = (value, bodyValues) => {
        HandleCarouselTemplate(value, setMediaLink, setExistingMediaIDs, setTemplateName, templates, setTemplateKey, setTemplateLanguage, setTemplatePreview, setMainBody, setCards, urlButtons, setMainBodyInputs, setCardData, setDynamicValues, bodyValues);
    };

    useEffect(() => {
        HandleDynamicValues(templatePreview, dynamicValues, setNewMessage)
    }, [templatePreview, dynamicValues])


    // for media model 
    const showMediaModel = (index) => {
        setCurrentCardIndex(index);  // Set the current card index
        setOpenMediaModel(true);
    };
    const handleCancelMediaModel = () => {
        setOpenMediaModel(false);
    };

    const HandleUploadImage = (path, name) => {
        if (path) {
            setExistingMediaIDs(prevMediaIDs => {
                const updatedMediaIDs = [...prevMediaIDs];
                updatedMediaIDs[currentCardIndex] = path; // Replace the media ID at the current index
                return updatedMediaIDs;
            });
            setCardData((prevData) =>
                prevData.map((card, index) =>
                    index === currentCardIndex
                        ? { ...card, mediaLink: path, mediaName: name }
                        : card
                )
            );
            setOpenMediaModel(false);
        }
    };
    ;


    const handleMediaLinkChange = (value, index) => {
        const newMediaLink = value;
        setCardData((prevData) =>
            prevData.map((card, i) =>
                i === index ? { ...card, mediaLink: newMediaLink } : card
            )
        );
    };

    const [showAlert, setShowAlert] = useState(false);
    const [isLoop, setIsLoop] = useState(true);

    useEffect(() => {
        if (showAlert) {
            message.error('Please provide the required media link and media type.');
        }
    }, [showAlert]);

    const Handlealidation = () => {
        //perform validation checks
        if (!name) {
            setError('Please enter a Preset name');
            return;
        }
        if (!templateCategory) {
            setError('Please select a Template Category');
            return;
        }

        if (!templateName) {
            setError('Please select a Template');
            return;
        }
        if (cardData.length === 0) {
            setError('Please add at least one card');
            return;
        }

        // Check if media links are provided for all cards
        if (cardData.some(card => !card.mediaLink)) {
            setError('Please provide media links for all cards');
            return;
        }
        // Check if mainBodyInputs are filled
        if (mainBodyInputs?.length !== dynamicValues?.length) {
            setError('Please fill all dynamic values in the main body');
        }

        // Check if all URL button values are filled
        const hasEmptyButtonValues = cardData.some((card, cardIndex) => {
            if (!card.buttons || (!Array.isArray(card.buttons) && !card.buttons.buttons)) {
                return false;
            }

            const buttonArray = card.buttons.buttons || card.buttons;
            return buttonArray.some((button, buttonIndex) => {
                // Only validate URL buttons with examples (dynamic values)
                if (button.type === 'URL' && button.hasOwnProperty('example')) {
                    const buttonValue = cardButtonValues[`${cardIndex}_${buttonIndex}`];
                    return !buttonValue || buttonValue.trim() === '';
                }
                return false;
            });
        });

        if (hasEmptyButtonValues) {
            setError('Please fill all URL button values');
            return;
        }
    }
    // Main handler function
    const ParepareRequest = async (e) => {
        setError('');
        e.preventDefault();

        // First, run validation to make sure all required fields are filled
        Handlealidation();

        // Stop if there are validation errors
        if (error) {
            return;
        }

        const missingCardIndices = cardData
            .map((card, index) => card.mediaType === 'Media' && !card.mediaLink ? index + 1 : null)
            .filter(index => index !== null);

        if (missingCardIndices.length > 0) {
            // Create a message listing all problematic card numbers
            const cardNumbers = missingCardIndices.join(', ');
            message.error(`Cards ${cardNumbers} are missing media files. Please select and upload files for these cards.`);
            return; // Prevent form submission if there are errors
        }
        else if (templateName === '') {
            setError('You have to select a template first');
            return;
        }
        try {
            // Generate message payloads
            const messagePayloads = generatePayload(':number:', templateName, templateLanguage, cardData, dynamicValues, cardButtonValues);
            // console.log('messagePayloads', messagePayloads);
            // return
            HandleSubmit(messagePayloads)
        } catch (error) {
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };


    const HandleSubmit = async (payload) => {

        setLoading(true);
        const data = {
            name: name, category: templateCategory, user_id: UserData?.id, object: payload
        }
        const url = !isEditing ? `${api}save-preset` : `${api}update-preset`
        if (isEditing) {
            data.id = editId
        }
        try {
            const response = await apiClient.post(url, data, {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            });
            if (response.data.status) {
                navigate('/carousel/Preset')
            }
        } catch (error) {
            setError(ErrorExtractor(error));
        } finally {
            setLoading(false);
        }
    }

    const handleSwitchChange = (checked) => {
        setIsLoop(checked)
    }

    useEffect(() => {
        if (existingMediaIDs?.length > 0 && !isEditing) { // Fix variable name here
            const updatedCardData = cardData.map((card, index) => ({
                ...card,
                mediaLink: existingMediaIDs[index] // Fix variable name here
            }));
            setCardData(updatedCardData)
        }
    }, [existingMediaIDs, isEditing]);



    const handleTabChange = (key) => {
        const newIndex = parseInt(key, 10);
        setCurrentCardIndex(newIndex);
    };
    return (
        <>
            <SelectMediaModel
                openMediaModel={openMediaModel}
                handleCancelMediaModel={handleCancelMediaModel}
                HandleUploadImage={HandleUploadImage}
            />
            <Row gutter={12}>
                {Permisson?.includes('View Campaign') &&
                    <>
                        <Col xs={24} sm={24} md={24} lg={16}>
                            <Card title="Carousel Preset">
                                {/* Error Alert */}
                                {error && (
                                    <Col span={24}>
                                        <motion.div
                                            initial={{ opacity: 0, marginBottom: 0 }}
                                            animate={{ opacity: error ? 1 : 0, marginBottom: error ? 20 : 0 }}
                                        >
                                            <Alert type="error" showIcon message={JSON.stringify(error)} />
                                        </motion.div>
                                    </Col>
                                )}
                                {/* Form */}
                                <Form
                                    name="basicInformation"
                                    labelCol={{ span: 8 }}
                                    // wrapperCol={{ span: 16 }}
                                    layout="vertical"
                                    initialValues={{ size: componentSize }}
                                    onValuesChange={onFormLayoutChange}
                                    size={componentSize}
                                >
                                    <Row gutter={[16, 16]}>
                                        {/* Campaign Name */}
                                        <Col span={isEditing ? 8 : 8}>
                                            <Form.Item
                                                label="Preset Name"
                                                name="Preset-Name"
                                                rules={[{ required: true, message: 'Please enter Preset name!' }]}
                                            >
                                                <Input type="text" value={name} onChange={(e) => setName(e.target.value)} />
                                                <p className="d-none">{name}</p>
                                            </Form.Item>
                                        </Col>
                                        {
                                            !isEditing &&
                                            <>
                                                {/* Template Category */}
                                                <Col span={6}>
                                                    <Form.Item label="Category" name="Template_category">
                                                        <Radio.Group
                                                            onChange={(e) => setTemplateCategory(e.target.value)}
                                                            value={templateCategory}
                                                        >
                                                            <Radio value="MARKETING">Marketing</Radio>
                                                            <Radio value="UTILITY">Utility</Radio>
                                                        </Radio.Group>
                                                    </Form.Item>
                                                    <p className="d-none">{templateCategory}</p>
                                                </Col>
                                                {/* Templates Selection */}
                                                {templateCategory && (
                                                    <Col span={8}>
                                                        <Form.Item label="Templates" name="Templates">
                                                            <Select
                                                                size="default"
                                                                style={{ width: '100%' }}
                                                                onChange={(value) => HandleTemplate(value)}
                                                                showSearch
                                                            >
                                                                <Select.Option value="choose...">Select</Select.Option>
                                                                {templateList?.length > 0 ? (
                                                                    templateList.map((item, index) => (
                                                                        <Select.Option value={item.name} key={index}>
                                                                            {item.name}
                                                                        </Select.Option>
                                                                    ))
                                                                ) : (
                                                                    <Select.Option value="">
                                                                        You Don't Have Any Approved Templates
                                                                    </Select.Option>
                                                                )}
                                                            </Select>
                                                        </Form.Item>
                                                    </Col>
                                                )}
                                            </>
                                        }
                                        {/* Dynamic Values */}
                                        {mainBodyInputs?.length > 0 && (
                                            <Col span={24}>
                                                {mainBodyInputs.map((input, index) => (
                                                    <div key={index} className="mb-2">
                                                        {input}
                                                    </div>
                                                ))}
                                            </Col>
                                        )}
                                        {/* Carousel Cards */}
                                        <CardData
                                            cardData={cardData}
                                            setCardButtonValues={setCardButtonValues}
                                            handleUrlButtonChange={handleUrlButtonChange}
                                            cardButtonValues={cardButtonValues}
                                            handleTabChange={handleTabChange}
                                            buttonStyle={buttonStyle}
                                            requiredMedia={true}
                                            showMediaModel={showMediaModel}
                                            handleMediaLinkChange={handleMediaLinkChange}
                                        />
                                        {/* Submit Buttons */}
                                        <Col span={24} className="mt-3 d-flex justify-content-end">
                                            <Form.Item>

                                                <Flex alignItems="center" gap={16}>
                                                    {/* make buck button */}
                                                    <Button
                                                        htmlType="submit"
                                                        onClick={() => navigate(-1)}
                                                        loading={loading}
                                                    >
                                                        Cancel
                                                    </Button>
                                                    {Permisson?.includes('Create Campaign') && (
                                                        <Button
                                                            // disabled={loading || isEditing || error}
                                                            type="primary"
                                                            htmlType="submit"
                                                            onClick={(e) => ParepareRequest(e)}
                                                            loading={loading}
                                                        >
                                                            {isEditing ? 'Update' : 'Save'} Preset
                                                        </Button>
                                                    )}
                                                </Flex>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Form>
                            </Card>
                        </Col>
                        {/* mobile preview  */}
                        <Col xs={24} sm={24} md={24} lg={6}>
                            <Card title={
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <span>Campaign Preview</span>
                                    <Flex alignItems='center'>
                                        <span className='h5 m-0 mr-2 p-0'>Auto Scroll</span>
                                        <Switch checked={isLoop} onChange={handleSwitchChange} />
                                    </Flex>
                                </div>
                            }>
                                <CarouselPreview
                                    mainBody={mainBody}
                                    mediaLink={existingMediaIDs}
                                    requestType={'template'}
                                    cards={cards}
                                    isLoop={isLoop}
                                    thumbnail={thumbnail}
                                    newMesaage={newMesaage}
                                    dynamicValues={dynamicValues}
                                    currentCardIndex={currentCardIndex}
                                    urlButtons={urlButtons}
                                    customMessage={null}
                                    requiredMedia={true}
                                />
                            </Card>
                        </Col>
                    </>
                }
            </Row >
        </>
    )
}
export default CarouselCampaign
